export default __webpack_public_path__ + "static/media/youtube-color-square.3b9948ba.svg";